<template>
  <div class="container">
    <!-- <div class="img">
      <img src="../assets/centerTop.png" alt="" />
      <p>请您补充和完善个人档案,方便查找您的资质证明！</p>
    </div> -->
    <div
      class="postionContainer"
      v-loading="loading"
      element-loading-text="上传中"
    >
      <div class="cardPerson">
        <div class="userTitle">
          <img
            :src="ruleForm.imageUrl"
            alt=""
            style="width: 100px; height: 120px"
            v-if="ruleForm.imageUrl"
          />
          <img
            src="@/assets/userpic.png"
            alt=""
            style="width: 100px; height: 120px"
            v-else
          />
        </div>
        <el-menu
          class="el-menu-vertical-demo"
          :default-active="activeIndex"
          @select="handleSelect"
        >
          <el-menu-item index="1">
            <i class="el-icon-user"></i>
            <span slot="title">个人信息</span>
          </el-menu-item>
          <el-menu-item index="2">
            <i class="el-icon-document"></i>
            <span slot="title">工作信息</span>
          </el-menu-item>
          <!-- <el-menu-item index="3">
            <i class="el-icon-edit-outline"></i>
            <span slot="title">资质升级记录</span>
          </el-menu-item> -->
          <el-menu-item index="4">
            <i class="el-icon-edit-outline"></i>
            <span slot="title">资质信息</span>
          </el-menu-item>
          <el-menu-item index="5">
            <i class="el-icon-document-checked"></i>
            <span slot="title">资质申请</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div v-show="activeIndex == 1">
        <el-card class="box-card">
          <div slot="header" class="boxHeader">
            <span>个人信息</span>
            <el-button
              type="primary"
              @click="submitForm('ruleForm')"
              :disabled="disabledUser"
              >保存</el-button
            >
          </div>
          <div class="informPersonal">
            <el-form
              :model="ruleForm"
              ref="ruleForm"
              :rules="ruleUser"
              label-width="120px"
              label-position="left"
            >
              <el-form-item label="头 像">
                <el-upload
                  action="#"
                  :on-remove="handleRemove"
                  list-type="picture-card"
                  :http-request="submitUpload"
                  :before-upload="beforeAvatarUpload"
                  :limit="1"
                  :file-list="fileList"
                  :multiple="false"
                  accept=".png,.jpg,.jpeg,.bmp"
                  :on-exceed="handleExceed"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="姓 名" prop="userName">
                <el-input
                  v-model="ruleForm.userName"
                  placeholder="请输入姓名"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item label="性别" prop="sex">
                <el-select v-model="ruleForm.sex" placeholder="请选择">
                  <el-option
                    v-for="(item, index) in sexList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="证件类型"
                prop="idcardType"
                style="margin-bottom: 29px"
              >
                <!-- @change="getLastChangeIndex(item)" -->
                <el-select
                  v-model="ruleForm.idcardType"
                  placeholder="请选择证件类型"
                  :disabled="true"
                >
                  <el-option
                    v-for="(item, index) in idCardList"
                    :key="index"
                    :label="item.value"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                prop="idcardNum"
                label="证件号码"
                style="margin-top: -7px"
              >
                <el-input
                  v-model="ruleForm.idcardNum"
                  type="text"
                  auto-complete="off"
                  placeholder="请输入证件号码"
                  :disabled="true"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="mobilePhone"
                label="联系手机"
                style="width: 100%"
              >
                <el-input
                  v-model="ruleForm.mobilePhone"
                  type="text"
                  auto-complete="off"
                  style="width: 53%"
                  placeholder="请输入手机号"
                ></el-input>
                <p style="word-wrap: break-word; font-size: 12px; width: 100%">
                  提示：分级评价人员、质量管理人员、合作伙伴 可用此手机号用于创新与知识产权管理能力分级评价服务系统登录账号。
                </p>
              </el-form-item>

              <el-form-item label="电子邮箱" prop="email">
                <el-input
                  placeholder="请输入电子邮箱"
                  v-model="ruleForm.email"
                ></el-input>
              </el-form-item>
              <el-form-item label="职称" prop="technicalTitle">
                <el-input
                  placeholder="请输入职称"
                  v-model="ruleForm.technicalTitle"
                ></el-input>
              </el-form-item>
              <el-form-item label="详细地址" required>
                <!-- <el-cascader
                  :options="addressOptions"
                  v-model="ruleForm.addressSele"
                  style="width: 100%"
                  clearable
                ></el-cascader> -->
                <div class="seleCity">
                  <el-form-item prop="province">
                    <el-select
                      v-model="ruleForm.province"
                      placeholder="省"
                      value-key="area_code"
                      @change="getprovince($event)"
                    >
                      <el-option
                        v-for="(item, index) in province"
                        :key="index"
                        :label="item.area_name"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="city"
                    ><el-select
                      v-model="ruleForm.city"
                      placeholder="市"
                      value-key="area_code"
                      @change="getcity($event)"
                    >
                      <el-option
                        v-for="(item, index) in city"
                        :key="index"
                        :label="item.area_name"
                        :value="item"
                      ></el-option> </el-select
                  ></el-form-item>
                  <el-form-item prop="county"
                    ><el-select
                      v-model="ruleForm.county"
                      placeholder="区/县"
                      value-key="area_code"
                      @change="getarea($event)"
                    >
                      <el-option
                        v-for="(item, index) in area"
                        :key="index"
                        :label="item.area_name"
                        :value="item"
                      ></el-option> </el-select
                  ></el-form-item>
                </div>
                <el-form-item prop="address" style="width: 100%">
                  <el-input
                    v-model="ruleForm.address"
                    type="text"
                    placeholder="请输入详细地址"
                  ></el-input>
                </el-form-item>
              </el-form-item>
              <el-form-item label="个人简介" prop="userText">
                <el-input
                  v-model="ruleForm.userText"
                  type="textarea"
                  placeholder="请输入个人简介"
                  maxlength="500"
                  rows="4"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </div>

      <div v-show="activeIndex == 2">
        <el-card class="box-card">
          <div slot="header" class="boxHeader">
            <div class="boxHeader">
              <span>工作信息</span>
              <el-button
                type="primary"
                @click="workSubmit('workForm')"
                :disabled="disabledWork"
                >保存</el-button
              >
            </div>
            <div
              style="
                margin: 10px 0;
                color: rgb(86, 127, 234);
                font-size: 12px;
                background: rgb(208, 225, 252);
                border-radius: 10px;
                padding: 10px;
                border: 1px dashed rgb(140, 218, 274);
              "
            >
              如需变更单位信息，请填写关于<a
                @click="download"
                class="red"
                style="
                  margin: 0 3px;
                  color: rgb(86, 127, 234);
                  font-style: italic;
                  cursor: pointer;
                  border-bottom: 1px solid rgb(86, 127, 234);
                "
                >申请变更单位信息的情况说明.docx</a
              >加附件发送至info@imspp.org.cn邮箱中，工作人员会在3个工作日内审核，如通过后会根据提交的文件完成变更。
              <!-- 如需变更单位信息，请提供离职证明+在职证明（包含单位名称、统一社会信用代码、加盖公章）或劳务合同发送至info@imspp.org.cn邮箱中，工作人员会在3个工作日内审核，如通过后会根据提交的文件完成变更。 -->
            </div>
          </div>
          <div class="informPersonals">
            <el-form
              :model="workForm"
              ref="workForm"
              :rules="ruleWork"
              label-width="150px"
              label-position="left"
            >
              <el-form-item label="单位名称" prop="unitName">
                <el-input
                  v-model="workForm.unitName"
                  placeholder="请输入单位名称"
                  :disabled="codeShow"
                ></el-input>
              </el-form-item>
              <el-form-item label="统一社会信用代码" prop="creCode">
                <el-input
                  v-model="workForm.creCode"
                  placeholder="请输入统一社会信用代码"
                  @blur="accountFn"
                  :disabled="show"
                ></el-input>
              </el-form-item>
              <el-form-item label="所在部门" prop="depart">
                <el-input
                  v-model="workForm.depart"
                  type="text"
                  auto-complete="off"
                  placeholder="请输入所在部门"
                ></el-input>
              </el-form-item>
              <el-form-item prop="post" label="所在岗位">
                <el-input
                  v-model="workForm.post"
                  type="text"
                  auto-complete="off"
                  placeholder="请输入所在岗位"
                ></el-input>
              </el-form-item>
              <el-form-item prop="dutyTime" label="工作开始时间">
                <el-date-picker
                  v-model="workForm.dutyTime"
                  type="date"
                  style="width: 100%"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
              <!-- <el-form-item prop="dutyTime" label="工作结束时间">
                <el-date-picker
                  v-model="value1"
                  type="date"
                  style="width: 100%"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item> -->
              <el-form-item label="主技术领域" prop="industry">
                <!-- :disabled="industryShow" -->
                <el-select
                  v-model="workForm.industry"
                  placeholder="请选择主技术领域"
                  :disabled="industryShow"
                >
                  <el-option
                    v-for="(item, index) in listIndustry"
                    :key="index"
                    :label="item.value"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="secondaryIndustry">
                <span slot="label" style="display: inline-block">
                  <el-tooltip
                    effect="dark"
                    content="次选技术领域须与主选技术领域有高度相关性"
                    placement="top-start"
                    style="margin: 0 2px"
                  >
                    <i class="el-icon-question" />
                  </el-tooltip>
                  次技术领域
                </span>
                <!-- :disabled="secondaryIndustryshow" -->
                <el-select
                  v-model="workForm.secondaryIndustry"
                  placeholder="请选择"
                  clearable
                  :disabled="industryShow"
                >
                  <el-option
                    v-for="(item, index) in listIndustry"
                    :key="index"
                    :label="item.value"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="附件"
                prop="fileOther"
                style="width: 100%"
                v-if="workForm.secondaryIndustry"
              >
                <span slot="label" style="display: inline-block">
                  <span style="color: red; margin-right: 3px">*</span>
                  附件
                </span>
                <!-- :on-remove="handleRemoveOther" -->
                <el-upload
                  v-if="!secondaryIndustryshow"
                  class="upload-demo"
                  action="#"
                  :multiple="false"
                  :limit="1"
                  :on-exceed="handleExceed"
                  :file-list="fileOther"
                  :show-file-list="false"
                  accept=".pdf,.png,.jpg,.bmp,.jpeg"
                  :before-upload="(file) => beforeAvatarUploadFiles(file, 1)"
                  :http-request="(file) => submitUploadOther(file, 1)"
                >
                  <el-button size="small" type="primary" plain>
                    <i class="el-icon-upload2"></i
                    >上传主次技术领域相关性的证明</el-button
                  >
                  <span slot="tip" class="el-upload__tip">
                    文件扩展名：pdf、jpg、png、jpeg、bmp
                  </span>
                </el-upload>
                <div>
                  <p
                    v-for="(item, index) in fileOther"
                    :key="index"
                    style="display: flex; width: 100%; margin: 0 0 0px 10px"
                  >
                    <span
                      style="
                        width: 500px;
                        display: inline-block;
                        overflow: hidden;
                        word-wrap: nowrap;
                      "
                      >{{ item.fileName }}</span
                    ><el-button
                      type="text"
                      style="color: #4b9ef1; margin-left: 10px"
                      v-if="!secondaryIndustryshow"
                      @click="handleRemoveOther(item, index)"
                      >删除</el-button
                    >
                  </p>
                </div>
              </el-form-item>
              <el-form-item label="详细地址" required>
                <div class="seleCity">
                  <el-form-item prop="province"
                    ><el-select
                      v-model="workForm.province"
                      placeholder="省"
                      value-key="area_code"
                      @change="workProvince($event)"
                    >
                      <el-option
                        v-for="(item, index) in province"
                        :key="index"
                        :label="item.area_name"
                        :value="item"
                      ></el-option> </el-select
                  ></el-form-item>

                  <el-form-item prop="city"
                    ><el-select
                      v-model="workForm.city"
                      placeholder="市"
                      value-key="area_code"
                      @change="workCity($event)"
                    >
                      <el-option
                        v-for="(item, index) in city"
                        :key="index"
                        :label="item.area_name"
                        :value="item"
                      ></el-option> </el-select
                  ></el-form-item>

                  <el-form-item prop="county">
                    <el-select
                      v-model="workForm.county"
                      placeholder="区/县"
                      value-key="area_code"
                      @change="workArea($event)"
                    >
                      <el-option
                        v-for="(item, index) in area"
                        :key="index"
                        :label="item.area_name"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <el-form-item prop="unitAddress" style="width: 100%">
                  <el-input
                    v-model="workForm.unitAddress"
                    type="text"
                    placeholder="请输入详细地址"
                  ></el-input>
                </el-form-item>
              </el-form-item>
              <el-form-item label="单位简介" prop="workText">
                <el-input
                  v-model="workForm.workText"
                  type="textarea"
                  placeholder="请输入单位简介"
                  maxlength="500"
                  rows="4"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </div>
      <div v-show="activeIndex == 3">
        <el-card class="box-card" style="min-height: 600px">
          <div slot="header" class="boxHeader">
            <span>资质升级记录</span>
          </div>
          <el-table
            :data="tableData"
            class="listTable"
            ref="scroll"
            style="min-height: 400px; cursor: pointer"
            :header-row-style="{
              color: '#333333',
              'font-size': '14px',
              'line-hight': '50px',
            }"
            header-align="center"
            :lazy="false"
            row-key="id"
            @expand-change="expandChange"
            @row-click="utilsFnect"
            :expand-row-keys="expandRowKeys"
          >
            <!-- empty-text="请耐心等待结果" -->
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-table
                  :data="tableChildData"
                  :empty-text="empty"
                  style="width: 90%; margin: 0 auto"
                >
                  <el-table-column
                    prop="auditDate"
                    label="审核日期"
                    width="200"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="auditResult"
                    label="审核结果"
                    width="200"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.auditResult == '0'">未通过</span>
                      <span v-if="scope.row.auditResult == '1'">待审核</span>
                      <span v-if="scope.row.auditResult == '2'">已通过</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="memo"
                    label="原因/说明"
                    show-overflow-tooltip
                    width="300"
                  >
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>

            <!-- <el-table-column
              prop="surname"
              label="姓名"
              width="140px"
              show-overflow-tooltip
            ></el-table-column>

            <el-table-column
              width="140px"
              prop="idcardNum"
              label="证件号码"
              show-overflow-tooltip
            ></el-table-column> -->
            <el-table-column
              width="120px"
              prop="qualTypeName"
              label="资质类型"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="cerCode"
              label="资质编号"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="nowQualLevelName"
              label="资质等级"
              width="80px"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              width="110px"
              prop="applyQualLevelName"
              label="升级资质等级"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              width="140px"
              prop="applyDate"
              label="提交日期"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="status" label="处理结果" width="80">
              <template slot-scope="scope">
                <span style="color: #f83d24" v-if="scope.row.status == '0'"
                  >未通过</span
                >
                <span style="color: #0be654" v-if="scope.row.status == '1'"
                  >待审核</span
                >
                <span style="color: #409eff" v-if="scope.row.status == '2'"
                  >已通过</span
                >
                <span style="color: #0be654" v-if="scope.row.status == '9'"
                  >待提交</span
                >
              </template>
            </el-table-column>
            <el-table-column prop="" label="操作" width="80">
              <template slot-scope="scope">
                <span
                  style="color: #409eff"
                  @click="editUserInfo(scope.row.id)"
                  v-if="scope.row.status != '2' && scope.row.status != '1'"
                  >编辑</span
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            v-if="pageshow"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 50, 100, 200]"
            :page-size="rows"
            layout="total,prev, pager, next, sizes,  jumper"
            :total="total"
          >
          </el-pagination>
        </el-card>
      </div>
      <div v-show="activeIndex == 4">
        <el-card class="box-card" style="min-height: 600px">
          <div slot="header" style="margin: 10px 0">
            <el-button @click="addCerity" type="primary" size="small"
              >添加证书</el-button
            >
          </div>
          <el-table
            :data="tabledataCer"
            ref="scroll"
            style="min-height: 400px; cursor: pointer"
            row-key="id"
          >
            <!-- empty-text="请耐心等待结果" -->

            <el-table-column
              prop="cerNum"
              label="证书编号"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span
                  @click="lookpdf(scope.row)"
                  style="color: rgb(61, 159, 240)"
                  >{{ scope.row.cerNum }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="cerName"
              label="证书名称"
              show-overflow-tooltip
              width="200"
              align="center"
            >
              <template slot-scope="scope">
                <span
                  @click="lookpdf(scope.row)"
                  style="color: rgb(61, 159, 240)"
                  >{{ scope.row.cerName }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="cerType"
              label="证书类别"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="startTime"
              label="证书开始日期"
              width="160"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="endTime"
              label="证书废止日期"
              width="160"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column prop="cerCode" label="操作" width="80">
              <template slot-scope="scope">
                <span
                  @click="delectCer(scope.row)"
                  style="cursor: pointer; color: red"
                  >删除</span
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="pagination"
            @size-change="handleSizeChangecer"
            @current-change="handleCurrentChangecer"
            :current-page="pageCer"
            :page-sizes="[10, 50, 100, 200]"
            :page-size="rowsCer"
            layout="total,prev, pager, next, sizes,  jumper"
            :total="totalCer"
          >
          </el-pagination>
        </el-card>
      </div>

      <div v-show="activeIndex == 5">
        <Qualificationlist
          @getCerlistdata="getCerlistdata"
          :cerlistData="cerlistData"
          @handleTableSort="handleTableSort"
          @delCer="delCer"
          :activeIndex="Number(activeIndex)"
        ></Qualificationlist>
      </div>
    </div>
    <el-dialog
      title="提示"
      width="30%"
      top="25vh"
      :visible.sync="dialogFormVisible"
    >
      <div
        style="
          height: 150px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-top: 1px solid #dddcdc;
          font-size: 15px;
        "
      >
        <i class="el-icon-success" style="color: #67c23a; font-size: 22px"></i
        ><span style="color: #000; margin-left: 5px">保存成功!</span>
      </div>
    </el-dialog>
    <el-dialog
      title="添加证书"
      width="40%"
      top="20vh"
      :visible.sync="dialogFormVisibles"
    >
      <el-form :model="formAdd" :rules="formAddRules" ref="formAdd">
        <el-form-item label="证书编号" label-width="130px" prop="cerCode">
          <el-input
            style="width: 60%"
            v-model="formAdd.cerCode"
            autocomplete="off"
            maxlength="50"
            @input="changeCercode"
            placeholder="请输入证书编号"
          ></el-input>
        </el-form-item>

        <el-form-item label="证书名称" label-width="130px" prop="cerName">
          <el-input
            style="width: 60%"
            v-model="formAdd.cerName"
            autocomplete="off"
            maxlength="50"
            @input="changeCername"
            placeholder="请输入证书名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="证书类别" label-width="130px" prop="cerSelect">
          <el-select
            v-model="formAdd.cerSelect"
            placeholder="请选择证书类别"
            style="width: 60%"
          >
            <el-option
              v-for="(item, index) in cerType"
              :key="index"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="startTime" label-width="130px" label="证书开始时间">
          <el-date-picker
            v-model="formAdd.startTime"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
            style="width: 60%"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="endTime" label-width="130px" label="证书结束时间">
          <el-date-picker
            v-model="formAdd.endTime"
            value-format="yyyy-MM-dd"
            type="date"
            clearable
            placeholder="选择日期"
            style="width: 60%"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="fileCert" label-width="130px" label="上传证书">
          <el-upload
            class="upload-demo"
            action="#"
            :multiple="false"
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="formAdd.fileCert"
            accept=".pdf,.png,.jpg,.bmp,.jpeg"
            :before-upload="(file) => beforeAvatarUploadFiles(file, 2)"
            :http-request="(file) => submitUploadOther(file, 2)"
            :on-remove="(file) => handleRemoves(file, 2)"
          >
            <el-button size="small" type="primary" plain>
              <i class="el-icon-upload2"></i> 点击上传</el-button
            >
            <span slot="tip" class="el-upload__tip">
              文件扩展名：pdf、jpg、png、jpeg、bmp
            </span>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addNo">取 消</el-button>
        <el-button type="primary" @click="addCerfrom" :disabled="disablecer"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 查看证书 -->
    <el-dialog
      title="查看证书"
      width="70%"
      top="10vh"
      :visible.sync="dialogFormVisibleLook"
    >
      <div style="margin: 0 auto; height: 100%; text-align: center">
        <img
          :src="url"
          alt=""
          v-if="!pdflook"
          style="margin: 30px auto; max-width: 100%"
        />
        <iframe
          v-if="pdflook"
          :src="url"
          frameborder="0"
          toolbar="0"
          style="border: none; width: 100%; min-height: 600px; height: 100%"
        ></iframe>
      </div>
    </el-dialog>
    <Foot class="foot" />
  </div>
</template>
  
<script>
import Qualificationlist from "./components/qualificationList.vue";
import Foot from "@/components/Foot.vue";
import {
  updatePersonInfo,
  checkRepeat,
  uploadAvatar,
  userInfo,
  getAreaLists,
  updatePersonUnit,
  fileInfo,
  getDictInfoNew,
  delAvatar,
  queryUpgradeList,
  queryQualificationsUpgradeAuditRecord,
  getPersonCer,
  addPersonCer,
  delPersonCer,
  uploadFile,
  delectFile,
  practicePage,
  delCers
} from "@/api/api.js";
import axios from "axios";
export default {
  name: "",
  components: { Foot, Qualificationlist },
  props: {},
  data() {
    //校验身份证号
    let checkMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入手机号"));
      } else if (!this.isCellPhone(value)) {
        // 引入methods中封装的检查手机格式的方法
        return callback(new Error("请输入正确的手机号!"));
      } else {
        callback();
      }
    };

    // 校验邮箱
    let checkEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入电子邮箱"));
      } else {
        const reg =
          /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
        if (!reg.test(value)) {
          const msg = rule.msg ? rule.msg : "邮箱格式不正确";
          return callback(new Error(msg));
        } else {
          return callback();
        }
      }
    };
    let checkUserId = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入统一社会信用代码"));
      } else {
        const reg = /^[A-Za-z0-9]{18}$/;
        // const regs = /^[A-Za-z0-9]{15}$/;
        if (!reg.test(value)) {
          const msg = rule.msg
            ? rule.msg
            : "统一社会信用代码长度18位数字、字母";
          return callback(new Error(msg));
        } else {
          return callback();
        }
      }
    };
    return {
      loading: false,
      tableChildData: [], //子表格数据信息
      expandRowKeys: [], //行数据的Key ，展开节点的keys
      showTabbler: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now(); // 选当前时间之后的时间
        },
      },
      pageshow: true,
      page: 1,
      rows: 10,
      total: 0,
      pageCer: 1,
      rowsCer: 10,
      totalCer: 0,
      tableData: [],
      fileOther: [],
      show: false,
      dialogVisible: false,

      province: [],
      city: [],
      area: [],
      form: {},
      // 个人资料数据
      ruleUser: {
        userName: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        sex: [
          {
            required: true,
            message: "请选择",
            trigger: "blur",
          },
        ],
        mobilePhone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: ["blur"],
          },
          { validator: checkMobile, trigger: "blur" },
        ],
        email: [
          { required: true, message: "电子邮箱不能为空", trigger: "blur" },
          {
            type: "email",
            max: 50,
            min: 9,
            message: "请输入正确的电子邮箱",
            trigger: ["blur", "change"],
          },
          { validator: checkEmail, trigger: "blur" },
        ],
        technicalTitle: [
          {
            required: true,
            message: "请输入职称",
            trigger: ["blur"],
          },
        ],
        province: [
          {
            required: true,
            message: "请选择省",
            trigger: ["blur", "change"],
          },
        ],
        city: [
          {
            required: true,
            message: "请选择市",
            trigger: ["blur", "change"],
          },
        ],
        county: [
          {
            required: true,
            message: "请选择区/县",
            trigger: ["blur", "change"],
          },
        ],
        address: [
          {
            required: true,
            message: "请输入详细地址",
            trigger: "blur",
          },
        ],
        userText: [
          {
            required: true,
            message: "请输入个人简介",
            trigger: "blur",
          },
        ],
      },
      ruleWork: {
        province: [
          {
            required: true,
            message: "请选择省",
            trigger: ["blur", "change"],
          },
        ],
        city: [
          {
            required: true,
            message: "请选择市",
            trigger: ["blur", "change"],
          },
        ],
        county: [
          {
            required: true,
            message: "请选择区/县",
            trigger: ["blur", "change"],
          },
        ],
        address: [
          {
            required: true,
            message: "请输入详细地址",
            trigger: "blur",
          },
        ],
        // 工作信息
        unitName: [
          {
            required: true,
            message: "请输入单位名称",
            trigger: "blur",
          },
        ],
        creCode: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "blur",
          },
          { validator: checkUserId, trigger: ["blur", "change"] },
        ],
        industry: [
          {
            required: true,
            message: "请选择主技术领域",
            trigger: ["blur", "change"],
          },
        ],
        depart: [
          {
            required: true,
            message: "请输入所在部门",
            trigger: "blur",
          },
        ],
        post: [
          {
            required: true,
            message: "请输入所在岗位",
            trigger: "blur",
          },
        ],
        dutyTime: [
          {
            required: true,
            message: "请选择工作开始时间",
            trigger: ["blur"],
          },
        ],
        unitAddress: [
          {
            required: true,
            message: "请输入详细地址",
            trigger: "blur",
          },
        ],

        workText: [
          {
            required: true,
            message: "请输入单位简介",
            trigger: "blur",
          },
        ],
      },
      ruleForm: {
        imageUrl: "", //图片上传
        userName: "",
        sex: "", //性别
        idcardType: "", //证件类型
        idcardNum: "",
        mobilePhone: "", //电话号码
        email: "",
        technicalTitle: "",
        addressSele: "",
        provinceCode: "",
        province: "",
        cityCode: "",
        city: "",
        countyCode: "",
        county: "",
        address: "",
        userText: "",
      },
      // 资质信息-证书
      url: "",
      tabledataCer: [],
      disablecer: false,
      dialogFormVisibles: false,
      dialogFormVisibleLook: false, //查看证书
      pdflook: false,
      formAddRules: {
        cerCode: [
          {
            required: true,
            message: "请输入证件编号",
            trigger: ["blur", "change"],
          },
        ],
        cerName: [
          {
            required: true,
            message: "请输入证件名称",
            trigger: ["blur", "change"],
          },
        ],
        cerSelect: [
          {
            required: true,
            message: "请选择证件类别",
            trigger: ["blur", "change"],
          },
        ],
        startTime: [
          {
            required: true,
            message: "请选择证书开始时间",
            trigger: ["blur", "change"],
          },
        ],
        // endTime: [
        //   {
        //     required: true,
        //     message: "请选择证书结束时间",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        fileCert: [
          {
            required: true,
            message: "请上传证书",
            trigger: ["blur", "change"],
          },
        ],
      },
      formAdd: {
        cerCode: "",
        cerName: "",
        cerSelect: "",
        startTime: "",
        endTime: "",
        fileCert: [],
      },
      cerType: [],
      sexList: [
        { label: "男", value: 1 },
        { label: "女", value: 2 },
      ],
      idCardList: [],
      // 工作信息数据
      workForm: {
        id: "",
        personId: "",
        unitName: "",
        creCode: "",
        industry: "",
        secondaryIndustry: "",
        depart: "",
        post: "",
        provinceCode: "",
        province: "",
        cityCode: "",
        city: "",
        countyCode: "",
        county: "",
        unitAddress: "",
        workStartTime: "",
        workEndTime: "",
        workMemo: "",
        dutyTime: "",
        workText: "",
      },

      disabledWork: false,
      disabledUser: false,
      formLabelWidth: "120px",
      dialogFormVisible: false,
      activeIndex: "1",
      msg: "",
      typeMsg: "",
      listIndustry: [],
      annexFile: {},
      imageUrl: "",
      imageUrls: "",
      fileList: [],
      photoId: "",
      codeShow: false,
      industryShow: false,
      secondaryIndustryshow: false,
      disableBtn: false,
      // urlDownload:require("./public/申请变更单位信息的情况说明.docx")
      cerListpage: 1,
      cerListsize: 10,
      cerlistData: [
      ],
      orderByAsc:'',
      orderByColumns:""
    };
  },
  computed: {},
  created() {
    // this.infoTab()
    var value = sessionStorage.getItem("user");
    if (value == "" || value == undefined) {
      sessionStorage.removeItem("index");
      this.$router.push({ name: "Signin" });
    }
    getDictInfoNew("ZSLB").then((res) => {
      this.cerType = res.data;
    });
  },
  mounted() {
    getDictInfoNew("ZJLX").then((res) => {
      this.idCardList = res.data;
    });
    getDictInfoNew("ZSLB").then((res) => {
      this.cerType = res.data;
    });
    if (sessionStorage.getItem("activeindex")) {
      let index = sessionStorage.getItem("activeindex");
      this.activeIndex = index;
      sessionStorage.setItem("activeindex", index);
    }
    this.infoTab();
    this.tabledatas();
    this.getCerlist();
    if (this.activeIndex == 1) {
      this.getCity();
    } else if (this.activeIndex == 2) {
      this.getWorkCity();
    }else if(this.activeIndex == 5){
      this.getCerlists()
    }
  },
  watch: {
    "formAdd.fileCert"(newVal) {
      if (newVal.length > 0) {
        this.$refs.formAdd.clearValidate("fileCert");
      }
    },
  },
  methods: {
    //验证手机号
    isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8)\d{9}$/.test(val)) {
        return false;
      } else {
        return true;
      }
    },
    showBtn() {
      this.show = true;
    },
    accountFn() {
      // const reg = /^[A-Za-z0-9]{15,18}$/;
      // if (!reg.test(this.workForm.creCode)) {
      //   this.$message.error("统一信用代码格式不正确");
      //   this.workForm.creCode = "";
      // }
    },
    // 资质申请列表
    getCerlists() {
      // cerlistData
      let data = {
        pageNum: this.cerListpage ,
        pageSize: this.cerListsize,
        orderByAsc: this.orderByAsc,
        orderByColumns: this.orderByColumns,
      };
      practicePage(data).then((res) => {
        this.cerlistData = res.data.list
      });
    },
    getCerlistdata(size, page) {
      this.cerListpage = page;
      this.cerListsize = size;
      this.getCerlists();
    },
    handleTableSort(val) {
      console.log(val);
      this.orderByAsc = val.orderByAsc;
      this.orderByColumns = val.orderByColumns;
      this.cerListpage = 1;
      this.getCerlists();
    },
    // 获取资质信息
    getCerlist() {
      let data = new FormData();
      data.append("pageNum", this.pageCer);
      data.append("pageSize", this.rowsCer);
      getPersonCer(data).then((res) => {
        if (res.code == 1000) {
          this.pageCer = res.data.pageNum;
          this.rowsCer = res.data.pageSize;
          this.totalCer = res.data.total;
          res.data.list.map((item) => {
            this.cerType.map((int) => {
              if (item.cerType == int.code) {
                item.cerType = int.value;
              }
            });
          });
          this.tabledataCer = res.data.list;
          this.$forceUpdate();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 添加证书
    addCerity() {
      this.dialogFormVisibles = true;
    },
    addNo() {
      this.dialogFormVisibles = false;
      this.$refs.formAdd.resetFields();
    },
    changeCername(value) {
      this.$forceUpdate();
      this.formAdd.cerName = value.replace(/\s+/g, "");
    },
    changeCercode(value) {
      this.$forceUpdate();
      this.formAdd.cerCode = value.replace(/\s+/g, "");
    },
    // 确定添加
    addCerfrom() {
      let user = JSON.parse(sessionStorage.getItem("user"));
      this.$refs.formAdd.validate((valid) => {
        if (valid) {
          if (this.formAdd.endTime == null || this.formAdd.endTime == undefined)
            this.formAdd.endTime = "";
          if (this.formAdd.endTime != "") {
            if (this.formAdd.endTime < this.formAdd.startTime) {
              this.$message.error("证书结束时间不能小于证书开始时间");
              return false;
            }
          }
          let data = new FormData();
          data.append("personId", user.id);
          data.append("cerNum", this.formAdd.cerCode);
          data.append("cerName", this.formAdd.cerName);
          data.append("cerType", this.formAdd.cerSelect);
          data.append("startTime", this.formAdd.startTime);
          data.append("endTime", this.formAdd.endTime);
          data.append("cerImage", this.formAdd.fileCert[0]);
          this.disablecer = true;
          addPersonCer(data).then((res) => {
            if (res.code == 1000) {
              this.dialogFormVisibles = false;
              this.getCerlist();
              this.$refs.formAdd.resetFields();
              this.$message.success("新增成功");
              this.disablecer = false;
            } else {
              this.$message.error(res.msg);
              this.disablecer = false;
            }
          });
        }
      });
    },
    // 查看证书
    lookpdf(row) {
      this.$forceUpdate();
      this.url = "";
      let baseUrl = window.global_config.BASE_URL;
      if (
        row.fileVo.annexName.includes("pdf") ||
        row.fileVo.annexName.includes("PDF")
      ) {
        this.pdflook = true;
      } else {
        this.pdflook = false;
      }
      this.dialogFormVisibleLook = true;
      setTimeout(() => {
        this.url =
          `${baseUrl}/v1/api/file/${row.fileVo.id}/view` +
          `?${Math.round(Math.random() * 100)}`;
      }, 10);
    },
    delectCer(row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // let data = new FormData();
          // data.append("id", row.id);
          delPersonCer(this.$qs.stringify({ id: row.id })).then((res) => {
            if (res.code == 1000) {
              this.getCerlist();
              this.$message.success("删除成功");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          console.log("error");
        });
    },
    delCer(row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delCers(this.$qs.stringify({ id: row })).then((res) => {
            if (res.code == "1000") {
              this.$message.success("删除成功");
              this.getCerlists()
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          console.log("error");
        });
    },
    beforeAvatarUploadFiles(file, type) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type == "image/bmp" ||
        file.type === "application/pdf";
      const isLt2M = file.size / 1024 / 1024 < 2;
      const isLt2Ms = file.size / 1024 / 1024 < 20;
      if (type == 1) {
        if (file.type === "application/pdf" && file.size / 1024 / 1024 > 20) {
          this.$message.error("上传附件大小不能超过 20MB!");
          return false;
        }
      } else {
        if (file.type === "application/pdf" && file.size / 1024 / 1024 > 5) {
          this.$message.error("上传附件大小不能超过 5MB!");
          return false;
        }
      }
      if (!isJPG) {
        this.$message.error("上传附件格式只能是jpg、png、jpeg、bmp、pdf。");
        return false;
      }
      if (
        (!isLt2M && file.type === "image/jpeg") ||
        (!isLt2M && file.type === "image/png") ||
        (!isLt2M && file.type === "image/jpg") ||
        (!isLt2M && file.type == "image/bmp")
      ) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return false;
      }
      let sameFilename = "";
      if (type == 1) {
        sameFilename = this.fileOther.filter((item) => item.name === file.name);
      } else {
        sameFilename = this.formAdd.fileCert.filter(
          (item) => item.name === file.name
        );
      }
      if (sameFilename.length > 0) {
        this.$message.warning(`文件${file.name}已经上传，此次跳过`);
        return false;
      }
      if (file.name.length > 50) {
        this.$message.error("文件名称不能超过50位");
        return false;
      }
      return (isJPG && isLt2M) || (isJPG && isLt2Ms);
    },
    //  上传附件
    submitUploadOther(file, type) {
      this.loading = true;
      let image = new FormData();
      // image.append("type", 7);
      image.append("file", file.file);
      // image.append("operId", "");
      // image.append("operId", this.workForm.id);
      if (type == 1) {
        image.append("type", "A");
      } else {
        image.append("type", "7");
      }

      // this.filelists.push(file.file)
      if (type == 1) {
        this.disabledWork = true;
        uploadFile(image).then((res) => {
          if (res.code == 1000) {
            this.disabledWork = false;
            this.loading = false;
            this.$message.success("上传成功");
            res.data.name = res.data.fileName;
            this.fileOther.push(res.data);
          } else {
            this.disabledWork = false;
            this.loading = false;
          }
        });
      } else {
        this.formAdd.fileCert.push(file.file);
        this.loading = false;
      }
    },
    handleRemoveOther(item, index) {
      this.$confirm("此操作会删除此技术领域证明, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delectFile(this.$qs.stringify({ id: item.id })).then((res) => {
            if (res.code == 1000) {
              this.$message.success("删除成功");
              // this.workForm.secondaryIndustry = "";
              this.fileOther.splice(index, 1);
            }
          });
        })
        .catch(() => {});
    },
    handleRemoves(file, fileList, type) {
      this.formAdd.fileCert.map((item, index) => {
        if (item.name == file.name) {
          this.formAdd.fileCert.splice(index, 1);
        }
      });
    },
    // 分页 -- 每页条数,当切换每页条数时，当前页码设置为：1 资质升级
    handleSizeChange(val) {
      this.rows = val;
      this.page = 1;
      this.tabledatas();
    },
    //分页 -- 当前页数
    handleCurrentChange(val) {
      this.page = val;
      this.tabledatas();
    },
    // 资质信息
    handleSizeChangecer(val) {
      this.rowsCer = val;
      this.pageCer = 1;
      this.getCerlist();
    },
    //分页 -- 当前页数
    handleCurrentChangecer(val) {
      this.pageCer = val;
      this.getCerlist();
    },
    infoTab() {
      if (sessionStorage.getItem("user")) {
        let user = JSON.parse(sessionStorage.getItem("user"));
        userInfo({ id: user.id }).then((res) => {
          let info = res.data.unitInfo;
          this.ruleForm = {
            // imageUrl: res.data.photoPath, //图片上传
            userName: res.data.examUserName,
            sex: res.data.sex, //性别
            idcardType: res.data.idcardType, //证件类型
            idcardNum: res.data.idcardNum,
            mobilePhone: res.data.mobilePhone, //电话号码
            email: res.data.email,
            technicalTitle: res.data.technicalTitle,
            province: res.data.province,
            city: res.data.city,
            county: res.data.county,
            countyCode: res.data.countyCode,
            cityCode: res.data.cityCode,
            provinceCode: res.data.provinceCode,
            address: res.data.address,
            // 个人简介
            userText: res.data.introduction,
          };

          // this.workForm.dutyTime = [info.workStartTime, info.workEndTime];
          // this.fileOther = info.annexFileList;
          this.fileOther = [];
          if (info.annexFileList.length > 0) {
            info.annexFileList.map((item) => {
              item.name = item.annexName;
              item.fileName = item.annexName;
              if (item.annexType == "A") {
                this.fileOther.push(item);
              }
            });
            // this.fileOther = info.annexFileList;
          }
          if (this.fileOther.length) {
            this.disableBtn = true;
          }
          this.workForm = {
            id: info.id,
            // personId: info.examUsersId,
            unitName: info.unit_name,
            creCode: info.creCode,
            industry: info.industry,
            secondaryIndustry: info.secondaryIndustry,
            depart: info.depart,
            post: info.post,
            provinceCode: info.provinceCode,
            province: info.province,
            cityCode: info.cityCode,
            city: info.city,
            countyCode: info.countyCode,
            county: info.county,
            unitAddress: info.unitAddress,
            workEndTime: info.workEndTime,
            workStartTime: info.workStartTime,
            dutyTime: info.workStartTime,
            // 单位简介
            workText: info.introduction,
          };
          if (this.workForm.unitName != "") {
            this.codeShow = true;
          }
          if (this.workForm.creCode != "") {
            this.show = true;
          }
          if (this.workForm.industry != "") {
            this.industryShow = true;
          }
          if (this.fileOther && this.fileOther.length != 0) {
            this.secondaryIndustryshow = true;
          }
          // if (this.workForm.industry != ""&&this.workForm.secondaryIndustry != ""&&this.fileOther.length == 0) {
          //   this.secondaryIndustryshow = true;
          // }

          this.fileList = [];
          let baseUrl = window.global_config.BASE_URL;
          let id = res.data.photoPath;
          this.$store.state.imgUrl = id;
          if (this.activeIndex == 1) {
            this.getCity();
          } else if (this.activeIndex == 2) {
            this.getWorkCity();
          }
          if (res.data.photoPath != "") {
            this.photoId = id;
            // this.imageUrl = `${baseUrl}/v1/api/file/${id}/view`+`?${Math.round(Math.random() * 100)}`;
            // this.imageUrls = `${baseUrl}/v1/api/file/${id}/view`+`?${Math.round(Math.random() * 100)}`;
            this.ruleForm.imageUrl =
              `${baseUrl}/v1/api/file/${id}/view` +
              `?${Math.round(Math.random() * 100)}`;
            sessionStorage.removeItem("img");
            sessionStorage.setItem("img", id);
            this.fileList.push({
              url:
                `${baseUrl}/v1/api/file/${id}/view` +
                `?${Math.round(Math.random() * 100)}`,
            });
          } else {
            // this.imageUrl = "";
            // this.imageUrls = "";
            this.ruleForm.imageUrl = "";
            this.fileList = [];
            sessionStorage.removeItem("img");
          }
        });
      }
      getDictInfoNew("HYLX").then((res) => {
        this.listIndustry = res.data;
      });
    },
    tabledatas() {
      let data = {
        pageNum: this.page,
        pageSize: this.rows,
      };
      queryUpgradeList(data).then((res) => {
        if (res.code == 1000) {
          this.tableData = res.data.list;
          this.page = res.data.page;
          this.rows = res.data.size;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    // 跳转资质升级
    editUserInfo(id) {
      this.$router.push({
        name: "qualificaUpgrade",
        params: { id: id, code: 1 },
      });
      sessionStorage.setItem("index", 5);
    },
    imageShow() {
      this.imageUrl = "";
    },
    getCity() {
      let data = {
        level: 1,
        parentCode: "",
      };
      getAreaLists(data).then((res) => {
        if (res.code == 1000) {
          this.province = res.data;
          let datas = {
            level: 2,
            parentCode: this.ruleForm.provinceCode,
          };
          getAreaLists(datas).then((res) => {
            if (res.code == 1000) {
              this.city = res.data;
              let datass = {
                level: 3,
                parentCode: this.ruleForm.cityCode,
              };
              getAreaLists(datass).then((res) => {
                if (res.code == 1000) {
                  this.area = res.data;
                }
              });
            }
          });
        }
      });
    },
    getWorkCity() {
      let data = {
        level: 1,
        parentCode: "",
      };
      getAreaLists(data).then((res) => {
        if (res.code == 1000) {
          this.province = res.data;
          let datas = {
            level: 2,
            parentCode: this.workForm.provinceCode,
          };
          getAreaLists(datas).then((res) => {
            if (res.code == 1000) {
              this.city = res.data;
              let datass = {
                level: 3,
                parentCode: this.workForm.cityCode,
              };
              getAreaLists(datass).then((res) => {
                if (res.code == 1000) {
                  this.area = res.data;
                }
              });
            }
          });
        }
      });
    },
    // 个人信息-地址
    getprovince(event) {
      this.ruleForm.province = event.area_name;
      this.ruleForm.provinceCode = event.area_code;
      this.ruleForm.city = "";
      this.ruleForm.cityCode = "";
      this.ruleForm.county = "";
      this.ruleForm.countyCode = "";
      // this.ruleForm.area = ''
      let data = {
        level: 2,
        parentCode: event.area_code,
      };
      getAreaLists(data).then((res) => {
        if (res.code == 1000) {
          this.city = res.data;
        }
      });
    },
    getcity(event) {
      this.ruleForm.city = event.area_name;
      this.ruleForm.cityCode = event.area_code;
      this.ruleForm.county = "";
      this.ruleForm.countyCode = "";
      let data = {
        level: 3,
        parentCode: event.area_code,
      };
      getAreaLists(data).then((res) => {
        if (res.code == 1000) {
          this.area = res.data;
        }
      });
    },
    getarea(event) {
      this.ruleForm.county = event.area_name;
      this.ruleForm.countyCode = event.area_code;
    },
    // 工作信息
    workProvince(event) {
      this.workForm.province = event.area_name;
      this.workForm.provinceCode = event.area_code;
      this.workForm.city = "";
      this.workForm.cityCode = "";
      this.workForm.county = "";
      this.workForm.countyCode = "";
      // this.workForm.area = ''
      let data = {
        level: 2,
        parentCode: event.area_code,
      };
      getAreaLists(data).then((res) => {
        if (res.code == 1000) {
          this.city = res.data;
        }
      });
    },
    workCity(event) {
      this.workForm.city = event.area_name;
      this.workForm.cityCode = event.area_code;
      this.workForm.county = "";
      this.workForm.countyCode = "";
      let data = {
        level: 3,
        parentCode: event.area_code,
      };
      getAreaLists(data).then((res) => {
        if (res.code == 1000) {
          this.area = res.data;
        }
      });
    },
    workArea(event) {
      this.workForm.county = event.area_name;
      this.workForm.countyCode = event.area_code;
    },
    submitForm() {
      //   var user = sessionStorage.getItem("user");
      // console.log(user);

      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (
            this.ruleForm.province == "" ||
            this.ruleForm.city == "" ||
            this.ruleForm.county == ""
          ) {
            this.$message.error("请选择省市区");
            return false;
          }
          let user = JSON.parse(sessionStorage.getItem("user"));
          let formData = {
            id: user.id,
            mobilePhone: this.ruleForm.mobilePhone,
            email: this.ruleForm.email,
            postTitle: this.ruleForm.technicalTitle,
            provinceCode: this.ruleForm.provinceCode,
            province: this.ruleForm.province,
            cityCode: this.ruleForm.cityCode,
            city: this.ruleForm.city,
            countyCode: this.ruleForm.countyCode,
            county: this.ruleForm.county,
            address: this.ruleForm.address,
            // 个人简介
            introduction: this.ruleForm.userText,
            surname: this.ruleForm.userName,
            sex: this.ruleForm.sex,
          };
          this.disabledUser = true;
          updatePersonInfo(formData).then((res) => {
            if (res.code == 1000) {
              this.dialogFormVisible = true;
              this.disabledUser = false;
              this.infoTab();
            } else {
              this.$message.error(res.msg);
              this.disabledUser = false;
            }
          });
        }
      });
    },
    workSubmit() {
      let user = JSON.parse(sessionStorage.getItem("user"));
      this.$refs.workForm.validate((valid) => {
        if (valid) {
          if (
            this.workForm.province == "" ||
            this.workForm.city == "" ||
            this.workForm.county == ""
          ) {
            this.$message.error("请选择省市区");
            return false;
          }
          if (this.workForm.secondaryIndustry && !this.fileOther.length) {
            this.$message.error("请上传主次技术领域相关性的证明");
            return false;
          }
          let data = {
            id: this.workForm.id,
            personId: user.id,
            unitName: this.workForm.unitName,
            idcardNum: this.ruleForm.idcardNum,
            creCode: this.workForm.creCode,
            industry: this.workForm.industry,
            secondaryIndustry: this.workForm.secondaryIndustry,
            depart: this.workForm.depart,
            post: this.workForm.post,
            provinceCode: this.workForm.provinceCode,
            province: this.workForm.province,
            cityCode: this.workForm.cityCode,
            city: this.workForm.city,
            countyCode: this.workForm.countyCode,
            county: this.workForm.county,
            unitAddress: this.workForm.unitAddress,
            workStartTime: this.workForm.dutyTime,
            // workEndTime: '',
            workMemo: "",
            introduction: this.workForm.workText,

            // 工作简介 workText
          };
          if (this.fileOther.length) {
            data.secondaryIndustryFileId = this.fileOther[0].id;
          }
          if (!this.workForm.secondaryIndustry && this.fileOther.length) {
            delectFile(this.$qs.stringify({ id: this.fileOther[0].id })).then(
              (res) => {
                if (res.code == 1000) {
                  this.fileOther = [];
                }
              }
            );
          }
          this.disabledWork = true;
          updatePersonUnit(data).then((res) => {
            if (res.code == 1000) {
              this.dialogFormVisible = true;
              this.infoTab();
              this.show = true;
              this.disabledWork = false;
            } else {
              this.$message.error(res.msg);
              this.disabledWork = false;
            }
          });
        }
      });
    },

    goIndex() {
      this.$router.push({ name: "index" });
    },
    handleSelect(key, keyPath) {
      this.activeIndex = key;
      sessionStorage.setItem("activeindex", key);
      if (this.activeIndex == 1) {
        this.getCity();
      } else if (this.activeIndex == 2) {
        this.getWorkCity();
      }else if(this.activeIndex == 5){
        this.getCerlists()
      }
    },
    //
    getChangeIdType(e) {
      console.log(e);
    },
    getLastChangeIndex(e) {
      console.log(e);
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type == "image/bmp";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传照片格式只能是jpg、png、jpeg、bmp。");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      if (file.name.length > 50) {
        this.$message.error("文件名称不能超过50位");
        return false;
      }
      return isJPG && isLt2M;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    // 图片上传功能
    submitUpload(files, fileList) {
      let image = new FormData();
      image.append("file", files.file);
      image.append("type", 1);
      // this.imageUrls = ''
      // this.imageUrl = ""
      uploadAvatar(image).then((res) => {
        if (res.code == "1000") {
          this.ruleForm.imageUrl = "";
          // this.imageUrls = URL.createObjectURL(files.file) +`?${Math.round(Math.random() * 100)}`;
          // this.imageUrl = URL.createObjectURL(files.file) +`?${Math.round(Math.random() * 100)}`;
          this.ruleForm.imageUrl =
            URL.createObjectURL(files.file) +
            `?${Math.round(Math.random() * 100)}`;
          this.$store.commit("setImg", ""); //设置Vuex中的数据，头部也要使用共享数据
          this.$store.commit("setImg", this.ruleForm.imageUrl); //设置Vuex中的数据，头部也要使用共享数据
          this.ruleForm.annexFile = res.data;
          this.$message.success("上传成功");
          this.infoTab();
          // this.$route.go(0);
        } else {
          // this.imageUrls = "";
          // this.imageUrl = "";
          this.ruleForm.imageUrl = "";
          this.ruleForm.annexFile = "";
          this.infoTab();
          this.$message.error(res.msg);
        }
      });
    },
    // 删除头像
    handleRemove(file, fileList) {
      this.annexFile = {};
      delAvatar(this.$qs.stringify({ id: this.photoId })).then((res) => {
        if (res.code == 1000) {
          this.$message.success("删除成功");
          this.infoTab();
          sessionStorage.removeItem("img");
          this.$store.commit("setImg", file.file); //设置Vuex中的数据，头部也要使用共享数据
          // this.$store.commit("setImg", file.file);//设置Vuex中的数据，头部也要使用共享数据
          // this.$router.go(0)
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    expandChange(row, expandedRows) {
      this.showTabbler = !this.showTabbler;
      // sessionStorage.setItem("row", JSON.stringify(row));
      // sessionStorage.setItem("expandedRows", JSON.stringify(expandedRows));
      this.expandRowKeys = [];
      this.expandRowKeys.push(row.id);
      //展开
      if (expandedRows.length != 0) {
        //查看子表数据 得分记录
        let id = row.id;
        queryQualificationsUpgradeAuditRecord(
          this.$qs.stringify({ id: id })
        ).then((res) => {
          if (res.code == "1000") {
            this.tableChildData = res.data;
            if (!res.data.length) {
              this.empty = "暂无数据";
            } else {
              this.empty = "";
            }
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        //收缩
        this.expandRowKeys = []; //展开行的id
        this.tableChildData = [];
      }
    },
    utilsFnect(row, expandedRows) {
      this.showTabbler = !this.showTabbler;
      this.expandRowKeys = [];
      this.expandRowKeys.push(row.id);
      //展开
      if (expandedRows.length != 0) {
        //查看子表数据 得分记录
        let id = row.id;
        queryQualificationsUpgradeAuditRecord(
          this.$qs.stringify({ id: id })
        ).then((res) => {
          if (res.code == "1000") {
            this.tableChildData = res.data;
            // this.empty=res.msg
            if (!res.data.length) {
              this.empty = "暂无数据";
            } else {
              this.empty = "";
            }
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        this.expandRowKeys = []; //展开行的id
        this.tableChildData = [];
      }
      // }
    },
    download() {
      let baseUrl = window.global_config.BASE_URL;
      axios({
        url: `${baseUrl}/v1/api/patentPerson/downloadQYBGSM`,
        method: "post",
        responseType: "blob",
        // data,
      }).then((res) => {
        if (res.status == 200) {
          console.log(res);
          // Blob 对象表示一个不可变、原始数据的类文件对象（File 接口都是基于Blob）
          const BLOB = res.data;
          // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
          const fileReader = new FileReader();
          // 开始读取指定的Blob中的内容。读取完成result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
          fileReader.readAsDataURL(BLOB);
          // 处理load事件，该事件在读取操作完成时触发
          fileReader.onload = (event) => {
            let a = document.createElement("a");
            // 赋值下载的文件名
            console.log(res.headers);
            let fileNames = res.headers["content-disposition"]
              .split(";")[1]
              .split("=")[1]; //获取到Content-Disposition;filename
            console.log(fileNames);
            a.download = `${decodeURI(fileNames)}`;
            a.href = event.target.result;
            document.body.appendChild(a);
            a.click();
          };
        }
      });
    },
    editQuity() {},
  },
};
</script>
  
<style scoped lang="less">
html,
body {
  background: #b9c1df;
}
.container {
  width: 100%;
  // background: #fff;
  height: calc(100% - 83px);
  // padding-top: 30px;
  box-sizing: border-box;
  overflow: auto;
  .header {
    width: 100%;
    background: #72f3b9;
    height: 150px;
    line-height: 100px;
    font-size: 16px;
  }

  .postionContainer {
    width: 1200px;
    margin: 20px auto 0 auto;

    display: flex;
    min-height: calc(100% - 100px);
    .cardPerson {
      width: 284px;
      height: 378px;
      background-color: #fff;
      border-radius: 4px;

      .userTitle {
        width: 130px;
        height: 150px;
        /* vertical-align: middle; */
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .el-menu {
        border-right: none;
      }
      .el-menu-item {
        border-left: 7px solid #fff;
        // background: #e8eeff;
        // text-align: center;
      }
      .el-menu-item.is-active {
        background: #d7e3fc;
        color: #607fea;
        border-left: 7px solid #5780f2;
      }
      .el-menu-item:hover {
        border-left: 7px solid #5780f2;
      }
    }

    .information {
      // display: flex;
      flex: 1;
      // height: 600px;
      overflow: auto;
      // border-bottom: 1px solid #f0f0f0;
      // justify-content: space-around;
      align-items: center;
      padding-bottom: 20px;
      margin-left: 25px;
      border: 1px solid #ccc;
      border-radius: 4px;

      .info_item {
        display: flex;
        margin: 20px;
        justify-content: flex-start;
        align-items: center;
        line-height: 50px;
        border-bottom: 1px solid #f0f0f0;

        span {
          margin: 0 20px;
        }
      }
    }
  }
}

::v-deep .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 80px;
  height: 80px;
  img {
    width: 100%;
    height: 100%;
  }
}
::v-deep .el-upload--picture-card {
  width: 80px;
  height: 80px;
  line-height: 82px;
}
::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 80px;
  height: 80px;
}
::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

::v-deep .avatar-uploader-icon {
  width: 70px;
  height: 80px;
  line-height: 80px;
}
.avatar-uploader {
  float: left;
  width: 80px;
  height: 80px;
  line-height: 80px;
}

.submitInfo {
  margin-top: 50px;
  line-height: 40px;
  font-size: 15px;

  .el-icon-success {
    font-size: 40px;
    color: rgb(46, 214, 46);
  }
}

.userInfor {
  margin: 30px 60px 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding-bottom: 10px;
  font-size: 15px;
  margin-bottom: 20px;
}

.seleCity {
  width: 100%;
  display: flex;
  justify-content: space-between;
  ::v-deep .el-form-item {
    width: 100% !important;
  }
  ::v-deep .el-select {
    width: 98%;
    ::v-deep .el-input {
      width: 100% !important;
    }
  }
}
.el-select {
  width: 100%;
}

::v-deep .el-dialog__header {
  text-align: left;
  // border-bottom: 1px solid #ccc;
  line-height: 25px;
  // display:flex;justify-content: flex-start;align-items: center;
}

::v-deep .el-dialog__title {
  font-size: 14px;
}
::v-deep .el-dialog__body {
  text-align: left;
  padding-top: 0;
  padding-bottom: 0;

  .span {
    // line-height: 40px;
    display: inline-block;
    margin: 0px 0 30px 30px;
    padding: 6px 20px;
    border-radius: 8px;
    background: #f0f0f0;
  }
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.boxHeader:before,
.boxHeader:after {
  display: table;
  content: "";
}

.boxHeader:after {
  clear: both;
}

.box-card {
  width: 898px;
  margin: 0 20px;
  padding: 0 20px;
  margin-bottom: 10px;
  box-sizing: border-box;
  // overflow:auto;

  .boxHeader {
    span {
      float: left;
      padding: 10px 0;
      font-size: 16px;
    }

    .el-button {
      float: right;
      width: 80px;
      height: 36px;
      background: #5780f2;
      border-radius: 6px;
    }
  }

  .avatar-uploader {
    float: left;
    width: 100px;
    height: 100px;
    line-height: 100px;
  }
  .el-upload {
    position: relative;
  }
  .el-icon-error {
    position: absolute;
    right: 3px;
    top: 3px;
    z-index: 9;
    font-size: 16px;
    cursor: pointer;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 0 2px #333;
  }
  ::v-deep .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 100px;
    height: 100px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  ::v-deep .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  ::v-deep .avatar-uploader-icon {
    width: 70px;
    height: 80px;
    line-height: 80px;
  }

  .el-input {
    // display: flex;
    width: 100%;
  }

  ::v-deep .el-input__inner {
    display: flex;
    // width: 100%;
    // background-color: #f2f6fd;
    // height: 36px;
  }

  ::v-deep .el-range-editor .el-range-input {
    // background-color: #f2f6fd;
    cursor: pointer;
  }
  ::v-deep .el-textarea__inner {
    // background-color: #f2f6fd;
    // color: #606266;
    font-family: 微软雅黑;
    min-height: 80px !important;
  }
  // ::v-deep .el-textarea .el-input__count {
  //   background-color: #f2f6fd;
  //   color: #000;
  //   bottom: 2px;
  //   right: 18px;
  // }
  ::v-deep .el-card__header {
    padding: 10px 20px;
  }

  .el-form-item {
    margin-bottom: 20px;
    width: 60%;
  }
}
::v-deep .el-table th.el-table__cell {
  background: #f5f5f5;
  color: #000;
}
::v-deep .el-pagination {
  text-align: right;
  margin-top: 20px;
}
.red:hover {
  color: red !important;
}
// .informPersonals {
//   .el-form-item {
//     margin-bottom: 30px;
//   }
// }
</style>
  